'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListType = require('./components/ListType.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListType).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-type/index.js
// module id = 1047
// module chunks = 0